import React from "react";
import { HashLink } from "react-router-hash-link";
import { createScope, map, transformProxies } from "./helpers";
import ButtonFullEffects from "../../components/webflow/ButtonFullEffects";
import ScrollSectionButton from "../../components/webflow/ScrollSectionButton";
import ScrollTopButton from "../../components/ScrollTopButton";
import SiteHeader from "../../components/SiteHeader";
import SiteFooter from "../../components/SiteFooter";
// import TypeAnimation from 'react-type-animation'
import ReactTextTransition, { presets } from "react-text-transition";
// https://www.npmjs.com/package/react-text-transition
import BookContent from "../../components/BookContent";

// const scripts = [
//   {
//     loading: fetch(
//       "https://d3e54v103j8qbb.cloudfront.net/js/jquery-3.5.1.min.dc5e7f18c8.js?site=61e48a462079c356c6452042"
//     ).then((body) => body.text()),
//     isAsync: false,
//   },
//   {
//     loading: fetch("js/webflow.js").then((body) => body.text()),
//     isAsync: false,
//   },
// ];

// let Controller;

// class IndexView extends React.Component {
//   state = {
//     textIndex: 0,
//     collapsiblesStates: [false, false, false, false, false],
//     noneOpen: true,
//   };

//   static get Controller() {
//     if (Controller) return Controller;

//     try {
//       Controller = require("../Index");
//       Controller = Controller.default || Controller;

//       return Controller;
//     } catch (e) {
//       if (e.code === "MODULE_NOT_FOUND") {
//         Controller = IndexView;

//         return Controller;
//       }

//       throw e;
//     }
//   }

//   componentDidMount() {
//     const htmlEl = document.querySelector("html");
//     htmlEl.dataset["wfPage"] = "6242288191da2b50c6937890";
//     htmlEl.dataset["wfSite"] = "61e48a462079c356c6452042";

//     scripts.concat(null).reduce((active, next) =>
//       Promise.resolve(active).then((active) => {
//         const loading = active.loading.then((script) => {
//           new Function(`
//           with (this) {
//             eval(arguments[0])
//           }
//         `).call(window, script);

//           return next;
//         });

//         return active.isAsync ? next : loading;
//       })
//     );

//     setInterval(() => {
//       this.setState({
//         textIndex: this.state.textIndex + 1,
//       });
//     }, 3000);
//   }

//   render() {
//     // const proxies = IndexView.Controller !== IndexView ? transformProxies(this.props.children) : {

//     // }

//     const buttonScrollToBookSectionProps = {
//       link: "index#thesolarexpress",
//       webflowanimate: true,
//     };

//     const buttonScrollToTopSectionProps = {
//       link: "index#top",
//     };

//     return (
//       <span>
//         <style
//           dangerouslySetInnerHTML={{
//             __html: `
//           @import url(/css/normalize.css);
//           @import url(/css/webflow.css);
//           @import url(/css/custom.webflow.css);
//         `,
//           }}
//         />
//         <span className="af-view">
//           <div>
//             <div className="af-class-page-wrapper">
//               <SiteHeader displayHome={false} />
//               <div
//                 id="top"
//                 className="af-class-section af-class-home-hero bg-[url('../images/background_space.jpg')] bg-cover"
//               >
//                 <div className="af-class-container-default w-container">
//                   <div>
//                     <div className="af-class-mg-bottom-large-72px">
//                       <div className="af-class-title-wrapper af-class-mg-bottom-24px w-full text-right">
//                         <h2 className="af-class-display-1 w-full af-class-color-white af-class-home-hero-title animate-xappearfadein text-3xl">
//                           The Solar Express...
//                         </h2>
//                       </div>
//                     </div>
//                     {/* <div className="af-class-_2-buttons-wrap max-w-[60vw] flex justify-between items-center flex-col lg:flex-row gap-y-3 animate-xappearfadein">
//                       <ButtonFullEffects {...buttonConnectProps} />
//                       <ButtonFullEffects {...buttonManifestoProps} />
//                     </div> */}
//                   </div>
//                 </div>
//                 <img
//                   src="images/earth_start.png"
//                   alt="Space Shuttle Start From Earth"
//                   className="af-class-image  af-bottom-left animate-xappear w-[40vw] max-w-[300px]"
//                 />
//                 <ScrollSectionButton {...buttonScrollToBookSectionProps} />
//               </div>
//               {/* <div
//                 id="thesolarexpress"
//                 className="af-class-section af-class-bg---100vh content-center items-center place-content-center" // content-center items-center place-content-center"
//               > */}
//               <div
//                 id="thesolarexpress"
//                 className="af-class-section af-class-home-hero content-center items-center place-content-center justify-center place-items-center" // content-center items-center place-content-center"
//               >
//                 <div
//                   //data-w-id="3eb5ca53-81ff-7c0d-f71c-03856ef027cb"
//                   className="w-[80vw] h-[80vh] max-h-[80vh]" //
//                 >
//                   <BookContent />
//                 </div>
//                 <ScrollTopButton {...buttonScrollToTopSectionProps} />
//               </div>
//               {/* <SiteFooter /> */}
//             </div>
//             {/* [if lte IE 9]><![endif] */}
//           </div>
//         </span>
//       </span>
//     );
//   }
// }

// export default IndexView;

export default function IndexView() {
  const buttonScrollToBookSectionProps = {
    link: "index#thesolarexpress",
    webflowanimate: true,
  };

  const buttonScrollToTopSectionProps = {
    link: "index#top",
  };

  return (
    <span>
      <span className="af-view">
        <div>
          <div className="af-class-page-wrapper">
            <SiteHeader displayHome={false} />
            <div
              id="top"
              className="af-class-section af-class-home-hero bg-[url('../images/background_space.jpg')] bg-cover"
            >
              <div className="af-class-container-default w-container">
                <div>
                  <div className="af-class-mg-bottom-large-72px">
                    <div className="af-class-title-wrapper af-class-mg-bottom-24px w-full text-right">
                      <h2 className="af-class-display-1 w-full af-class-color-white af-class-home-hero-title animate-xappearfadein text-3xl">
                        The Solar Express...
                      </h2>
                    </div>
                  </div>
                  {/* <div className="af-class-_2-buttons-wrap max-w-[60vw] flex justify-between items-center flex-col lg:flex-row gap-y-3 animate-xappearfadein">
                      <ButtonFullEffects {...buttonConnectProps} />
                      <ButtonFullEffects {...buttonManifestoProps} />
                    </div> */}
                </div>
              </div>
              <img
                src="images/earth_start.png"
                alt="Space Shuttle Start From Earth"
                className="af-class-image  af-bottom-left animate-xappear w-[40vw] max-w-[300px]"
              />
              <ScrollSectionButton {...buttonScrollToBookSectionProps} />
            </div>
            {/* <div
                id="thesolarexpress"
                className="af-class-section af-class-bg---100vh content-center items-center place-content-center" // content-center items-center place-content-center"
              > */}
            <div
              id="thesolarexpress"
              className="af-class-section af-class-home-hero content-center items-center place-content-center justify-center place-items-center h-[100vh] overflow-hidden" // content-center items-center place-content-center"
            >
              <div
                //data-w-id="3eb5ca53-81ff-7c0d-f71c-03856ef027cb"
                className="w-[80vw] max-h-[80vh] flex" //
              >
                <BookContent />
              </div>
              <ScrollTopButton {...buttonScrollToTopSectionProps} />
            </div>
            {/* <SiteFooter /> */}
          </div>
          {/* [if lte IE 9]><![endif] */}
        </div>
      </span>
    </span>
  );
}
